import { InputDateFilter } from '@/components';
import { ImportFCLData } from '@/types/tableImportFCL';
import { formatDate } from '@/utils/formatDate';
import {
  ColumnProps,
  ColumnFilterElementTemplateOptions,
} from 'primereact/column';
import ModalDetails from './ModalDetailImportFCL';
import DeleteImportFCL from './DeleteImportFCL';

export const getTableColumns = (
  t: (key: string) => string,
  isExport: boolean,
  tipo?: 'Import' | 'Export' | 'VacioImportacion',
  disabled?: boolean
): ColumnProps[] => {
  const body: ColumnProps[] = [
    {
      field: 'oid',
      header: '',
      filter: false,
      showFilterMenu: false,
      sortable: false,
      selectionMode: 'multiple',
      headerStyle: { width: '3rem' },
      headerClassName: 'child-hidden',
    },
    {
      field: 'marcaNumero',
      header: t('importFCL:containerNumber'),
      filter: false,
      showFilterMenu: false,
      sortable: true,
      body: (rowData: ImportFCLData) => (
        <strong>
          {(rowData.marcaNumero || '').replace('/', '').replace('-', '')}
        </strong>
      ),
    },
    ...(tipo !== 'VacioImportacion'
      ? [
          {
            field: '',
            header: isExport
              ? t('exportFCL:withdrawalDateExport')
              : t('importFCL:withdrawalDate'),
            filter: false,
            showFilterMenu: false,
            sortable: true,
            filterElement: (options: ColumnFilterElementTemplateOptions) => (
              <InputDateFilter options={options} />
            ),
            body: (rowData: ImportFCLData) =>
              formatDate(
                isExport ? rowData?.fechaIngreso : rowData?.fechaRetiro
              ),
          },
        ]
      : []),

    {
      field: 'importe',
      header: t('importFCL:amount'),
      filter: false,
      sortable: true,
      body: (rowData: ImportFCLData) =>
        Number(rowData.importe).toLocaleString('es-UY', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
    },
    {
      field: 'modalDetails',
      header: '',
      filter: false,
      showFilterMenu: false,
      sortable: false,
      headerStyle: { width: '3rem' },
      body: (rowData: ImportFCLData) => (
        <div className="flex justify-center gap-2">
          <ModalDetails rowData={rowData} />
          <DeleteImportFCL items={[rowData?.oid]} disabled={disabled} />
        </div>
      ),
    },
  ];

  if (!isExport && tipo !== 'VacioImportacion') {
    body.splice(3, 0, {
      field: 'entregaDirecta',
      header: t('importFCL:direct'),
      filter: false,
      sortable: true,
      body: (rowData: ImportFCLData) => (rowData.entregaDirecta ? 'Sí' : 'No'),
    });
  }

  return body;
};
